import { Tab } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ROUTER_PATHS, useTabsFormOnly } from '@/shared';
import {
  MarkAsReviwedPreagendamientoData,
  useUpdatePreagendamiento,
} from '@/shared/actions/erp';
import { FormTabsOnly, TabsFormBoxScene } from '@/shared/components/ui';
import { IPreagendamiento } from '@/shared/interfaces';
import { a11yProps } from '@/shared/utils';
import {
  InternetServicePreagendaFormTab,
  PreagendaProspectoDataFormTab,
} from '../SavePreagendamientoPyL';
import { SaveFormDataPreagendamiento } from '../../interface/SaveFormDataPreagendamiento';

export interface SavePreagendamientoPyLProps {
  title: string;
  preagendamiento: IPreagendamiento;
}

export type SaveFormDataUpdatedPreagendamiento =
  SaveFormDataPreagendamiento & {};



const SaveUpdatedPreagendaPyL: React.FC<SavePreagendamientoPyLProps> = ({
  preagendamiento,
  title,
}) => {
  const navigate = useNavigate();
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* local state --------------------
  const [shrink] = useState(true);

  ///* form --------------------
  const form = useForm<SaveFormDataUpdatedPreagendamiento>({
    defaultValues: {
      estado: true,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = form;

  ///* mutations --------------------
  const updatePreagendamientoMutation =
    useUpdatePreagendamiento<MarkAsReviwedPreagendamientoData>({
      navigate,
      returnUrl: returnUrlAgendamientosPyLPage,
    });

  ///* handlers --------------------
  const onSave = async () => {
    if (!isValid) return;

    ///* upd
    if (preagendamiento?.id_preagendamiento) {
      updatePreagendamientoMutation.mutate({
        id: preagendamiento.id_preagendamiento!,
        data: {
          revisado_pyl: true,
          fecha_revision_pyl: dayjs().format(),
        },
      });
      return;
    }
  };

  ///* effects --------------------
  useEffect(() => {
    if (!preagendamiento?.id_preagendamiento) return;

    const {
      preventa_data,
      prospecto_data,
      pais_data,
      provincia_data,
      ciudad_data,
      zona_data,
      sector_data,
      plan_data,
      flota_data,
      ...rest
    } = preagendamiento;
    reset({
      ...prospecto_data,
      ...preventa_data,
      ...rest,
      nacionalidad: pais_data?.nacionalidad!,
      observacion_1: preventa_data?.observaciones.observacion_1 || '',
      observacion_2: preventa_data?.observaciones.observacion_2 || '',

      vendedor_name: 'TODO: vendedor',
      es_referido: !!preventa_data?.tipo_referido ? 'SI' : 'NO',
      planLabel: plan_data?.nombre!,
      velocidad_internet: preventa_data?.velocidad
        ? `${preventa_data?.velocidad} ${plan_data?.unidad}`
        : '',

      flotaRaw: flota_data,
    } as unknown as SaveFormDataUpdatedPreagendamiento);
  }, [preagendamiento, reset]);

  return (
    <TabsFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlAgendamientosPyLPage)}
      onSave={handleSubmit(onSave)}
      saveTextBtn="Marcar como revisado"
      // tabs
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="DATOS PERSONALES" value={1} {...a11yProps(1)} />
          <Tab label="DATOS DE SERVICIO" value={2} {...a11yProps(2)} />
        </FormTabsOnly>
      }
    >
      {/* =================== Prospect Data =================== */}
      <PreagendaProspectoDataFormTab
        form={form}
        shrink={shrink}
        index={1}
        value={valueTab}
        preagendamiento={preagendamiento!}
        isCorrectingData
      />

      {/* =================== Service Data =================== */}
      <InternetServicePreagendaFormTab
        form={form}
        shrink={shrink}
        index={2}
        value={valueTab}
        preagendamiento={preagendamiento!}
        isCorrectingData
      />
    </TabsFormBoxScene>
  );
};

export default SaveUpdatedPreagendaPyL;
